<template lang="pug">
v-snackbar(
  v-if="snackbar",
  v-model="snackbar",
  :timeout="timeout",
  :absolute="absolute",
  :right="right",
  :left="left",
  :top="top",
  :bottom="bottom")
  | {{ message }}
  template(v-slot:action="{ attrs }")
    v-btn(:color="color", text, v-bind="attrs", @click="snackbar = false")
      | Close
</template>
<script>
export default {
  name: "TheSnackBar",
  data: () => ({
    snackbar: false,
    message: "",
    color: "blue",
    timeout: 2000,
    absolute: false,
    right: false,
    left: false,
    top: false,
    bottom: false
  }),
  created: function() {
    this.$eventHub.$on("on-show-snackbar", this.show);
  },
  beforeDestroy: function() {
    this.$eventHub.$off("on-show-snackbar");
  },
  methods: {
    show(obj) {
      this.message = obj.message;
      this.color = obj.color || "blue";
      this.timeout = obj.timeout || 2000;
      this.setDefaultPosition(obj.position);
      this.snackbar = true;
    },
    setDefaultPosition(obj) {
      this.absolute = false;
      this.right = false;
      this.left = false;
      this.top = false;
      this.bottom = false;

      if (obj) {
        this.absolute = obj.absolute || false;
        this.right = obj.absolute || false;
        this.left = obj.left || false;
        this.top = obj.top || false;
        this.bottom = obj.bottom || false;
      }
    }
  }
};
</script>
